module.exports = __webpack_public_path__ + "static/media/drumnow-6.b4f34eaa.jpg";